module.exports = __webpack_public_path__ + "static/media/(V)_MG_6273_-_Joias_Contenporaneas.6565405c.jpg";